module.exports = __webpack_public_path__ + "img/g-vip-bg3.6d3f815f.png";